import { IFollowUpSurveyForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IFollowUpSurveyForList,
    onConfirm: () => void,
    onCancel: () => void
}

const MarkIncomplete = (props: IProps) => {
    let fullName = props.data != null ? props.data.firstName + ' ' + props.data.lastName:'';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Survey Incomplete for <span style={{ color: 'darkgreen', fontWeight: 'bold' }}>{fullName}</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Please confirm that you wish to mark donor <strong>{fullName}</strong> as incomplete.
                <br /><br />
                This will remove <strong>{fullName}</strong> from any pending status tab.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm Incomplete</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MarkIncomplete;